import React, { useState, useRef, useEffect } from "react";
import Bredcrum from "../../components/bredcrum";
import { Toast } from "primereact/toast";
import { saleServices } from "../../services/saleServices";
import { productservices } from "../../services/productServices";
import { shipmentServices } from "../../services/shipmentServices";
import { Submissionbtn } from "../../components/buttons";
import {Loaderoverlay} from "../../components/loaderComp";
import {useStock} from '../../contexts/stockContexts'; 

import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { useFormikContext,useFormik,Field,Formik,Form,FieldArray,ErrorMessage  } from 'formik';
import {useSelector} from 'react-redux';
import { useNavigate } from "react-router-dom";
import {HandleClose} from '../../helpers/formclose';

function AddSale() {
  const toast = useRef(null);
  const navigate = useNavigate();
   const currencyreducer = useSelector((state)=>state.currencyreducer);
  const [productlist,setProductlist] = useState([]);
  const [components,setComponents] = useState({});
  const [isNewCustomer, setIsNewCustomer] = useState(true);
  const [currencies,setCurrencies] = useState([]);
  const [freightlist,setFreightlist] = useState([]);
  const [submitted,setSubmitted] = useState(true);
  const [isloaded,setLoading] = useState(true);
  const [customerData, setCustomerData] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState({});
  const {updateStock,getSettingValue} = useStock();
  const customerOption = [];
  const [formData, setFormData] = useState({
        order_id:"",
        sales_channel:"",
        product_id:"",
        units_sold:"",
        sku_code:"",
        sales_price:"",
        freight_charges:"",
        royalties:"",
        stock_reduction:"",
        order_status:"",
        currency: getSettingValue('default_currency'),
        customer_name: "",
        customer_email: "",
        customer_mobile: "",
        freight_provider: "",
        freight_currency: getSettingValue('default_currency')
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

    useEffect(()=>{
      getproduct();
      generateOrderId()
      getcurrency();
      getfreightlist();
      getCustomerData();
    },[]);

  const generateOrderId = async () => {
  const response = await saleServices.getLastOrderId();
  if (response.status === 200) {
    const lastId = response.data?.order_id || "UT - 000";
    const number = parseInt(lastId.replace("UT - ", ""), 10) + 1;
    const newId = `UT - ${number.toString().padStart(3, "0")}`;
    setFormData(prev => ({ ...prev, order_id: newId,currency:getSettingValue('default_currency') }));
  }
};

  const handleSubmit = async (values) => {
    setSubmitted(false);
    saleServices.createsale(values).then(async (response)=> {
        if(response.status == 200){
            setFormData(formData);
            setSubmitted(true);
            await toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Sale added successfully' });    
            const randomNum = Math.random();
            updateStock(randomNum); 
            navigate(-1);
        }else{
            setSubmitted(true);
            toast.current.show({ severity: 'error', summary: 'Sale', detail: response.data.message });     
        }
    }).catch((error)=>{
        setSubmitted(true);
        if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            if(errors == "Customer already present"){
                toast.current.show({
                  severity:'error',
                  summary:'Customer is present use new customer',
                  detail: errors
                });
            }else{   
              // Show each error using toast
              Object.keys(errors).forEach((field) => {
                  const fieldErrors = Array.isArray(errors[field]) ? errors[field] : [errors[field]];
                  fieldErrors.forEach((msg) => {
                      toast.current.show({
                          severity: 'error',
                          summary: field,
                          detail: msg,
                          life: 5000
                      });
                  });
              });
            }
        } else {
            toast.current.show({ 
                severity: 'error', 
                summary: 'Sale', 
                detail: 'An unexpected error occurred' 
            });
        }
    });
    console.log(formData); // You can send this to your API
  };

  const handleClose = () => {
    setFormData({
        order_id:"",
        sales_channel:"",
        product_id:"",
        units_sold:"",
        sku_code:"",
        sales_price:"",
        freight_charges:"",
        royalties:"",
        stock_reduction:"",
        order_status:"",
  });
}

  const getproduct = () =>{
     setLoading(false);
    productservices.getstockproduct().then((response)=>{
        if(response.status ==200){
            setProductlist(response.data.data);
            setLoading(true);
        }else{
            setProductlist([]);
            setLoading(true);
        }
      }).catch((error)=>{
          setProductlist([]);
          setLoading(true);
      });
  }
    function displayproduct(){
    let productdata = [];
    productlist.forEach((value,index)=>{
      productdata.push(<option value={value.id}>{value.product_name}</option>); 
    });

    return productdata;
  }

  const getCustomerData = ()=>{
    productservices.getCustomerData().then((response)=>{
      if(response.status == 200){
        setCustomerData(response.data.data)
      }
    })
  }

  for(let i=0; i<customerData.length; i++){
    customerOption.push(<option value={customerData[i].customer_name}>{customerData[i].customer_name}</option>)
  }

const validate = (values) => {
  const errors = {};
  const selectedProduct = productlist.find((p) => p.id == values.product_id);


  if (!values.order_id) errors.order_id = "Order ID is required";
  if (!values.sales_channel) errors.sales_channel = "Sales Channel is required";
  if (!values.product_id) errors.product_id = "Product is required";
  if (!values.sku_code) errors.sku_code = "SKU Code is required";

  if (!values.units_sold) {
    errors.units_sold = "Units Sold is required";
  } else if (parseInt(values.units_sold) < 1) {
    errors.units_sold = "Must be at least 1";
  } else if (
    selectedProduct &&
    parseInt(values.units_sold) > selectedProduct.available_stock
  )
  //  {
  //   errors.units_sold = `Units Sold (${values.units_sold}) cannot exceed Available Stock (${selectedProduct.available_stock})`;
  // }

  if (!values.sales_price) errors.sales_price = "Sales Price is required";
  if (!values.order_status) errors.order_status = "Order Status is required";
  if (!values.customer_name) errors.customer_name = "Customer Name is required";
  if (!values.customer_email) errors.customer_email = "Customer Email is required";
  if (!values.customer_mobile) errors.customer_mobile = "Customer Mobile No. is required";

  return errors;
};
const getEmptyForm = () => ({
  order_id: generateOrderId(),
  sales_channel: '',
  product_id: '',
  units_sold: '',
  sku_code: '',
  sales_price: '',
  freight_charges: '',
  royalties: '',
  stock_reduction: '',
  order_status: '',
  customer_name: '',
  customer_email: '',
  customer_mobile: '',
});
const getcurrency = () => {
    currencyreducer.then((response)=>{
      
       console.log("currency reducer");
       console.log(response);
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 
const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
       items.push(<option key={index} value={value.code}>{value.code}</option>);
    })  
    return items;
  }
    const getfreightlist = () =>{
      shipmentServices.getfreightlist().then((response)=>{
        console.warn(response);
          if(response.status ==200){
              setFreightlist(response.data.data);  
          }else{
              setFreightlist([]); 
          }
           
        }).catch((error)=>{
              setFreightlist([]); 
        });
    }


    

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Sales / Create manual Sale"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}
        <Loaderoverlay isloaded={isloaded}/>

        {/* <Titlebar text={"Add Sales Overview Details"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4">
                      <Formik initialValues={formData} enableReinitialize validate={validate} onSubmit={handleSubmit}>
                          {({ values, handleChange, setFieldValue, touched, errors,resetForm  }) => (
                            <Form>
                              <div className="row">
                                {/* Order ID */}
                                <div className="col-md-6 form-group">
                                  <label>Order ID</label>
                                  
                                  <Field
                                    type="text"
                                    name="order_id"
                                    className="form-control"
                                    placeholder="Enter Order ID"
                                    required
                                    value={values.order_id}
                                   
                                  />
                                  <ErrorMessage name="order_id" component="div" className="text-danger" />
                                </div>

                                
                                {/* Sales Channel */}
                                <div className="col-md-6 form-group">
                                  <label>Sales Channel</label>
                                  <Field
                                  as="select"
                                  name="sales_channel"
                                  className="form-control"
                                  required
                                >
                                  <option value="">Select Sales Channel</option>
                                  <option value="Shopify">Shopify</option>
                                  <option value="Superdrug">Superdrug</option>
                                  <option value="Amazon">Amazon</option>
                                  <option value="eBay">eBay</option>
                                </Field>
                                <ErrorMessage name="sales_channel" component="div" className="text-danger" />
                                </div>

                                <div className="col-md-6 form-group">
                                  <label>Sales Date</label>
                                  <Field
                                  type="datetime-local"
                                  name="sales_date"
                                  className="form-control"
                                  required
                                />
                                  
                                <ErrorMessage name="sales_channel" component="div" className="text-danger" />
                                </div>

                                {/* Product Sold */}
                                <div className="col-md-6 form-group">
                                  <label>Product Sold : <span className="text-info">(Products in Stock only visible)</span></label>
                                  <Field
                                as="select"
                                name="product_id"
                                className="form-control"
                                required
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setFieldValue(name, value);

                                  // Find SKU from selected product
                                  const selectedProduct = productlist.find(p => String(p.id) === value);
                                  if (selectedProduct) {
                                    setFieldValue("sku_code", selectedProduct.sku_code);
                                  } else {
                                    setFieldValue("sku_code", "");
                                  }
                                }}
                              >
                                <option value="">Select Product</option>
                                {productlist.map((product) => (
                                  <option key={product.id} value={product.id}>
                                    {product.product_name}
                                  </option>
                                ))}
                              </Field>
                                <ErrorMessage name="product_id" component="div" className="text-danger" />
                                </div>

                                {/* Units Sold */}
                                <div className="col-md-6 form-group">
                                  <label>Units Sold</label>
                                  <Field
                                    type="number"
                                    name="units_sold"
                                    className="form-control"
                                    placeholder="Enter Units Sold"
                                    required
                                  />
                                  {/* <ErrorMessage name="units_sold" component="div" className="text-danger" /> */}
                                </div>

                                {/* SKU Code */}
                                <div className="col-md-6 form-group">
                                  <label>Product SKU Code</label>
                                  <Field
                                type="text"
                                name="sku_code"
                                className="form-control"
                                value={values.sku_code}
                                readOnly // or disabled
                              />
                    <ErrorMessage name="sku_code" component="div" className="text-danger" />
                                </div>

                                {/* Sales Price */}
                                <div className="col-md-6 form-group">
                                  <label>Selling Price <span className="text-warning">(Per Unit)</span></label>
                                  <div className="flex-box">
                                            <Field as="select" name="currency" className="form-control" style={{width:'100px'}}
                                          // Update Formik state
                                      >
                                            {displayCurrency()}
                                    </Field>   <Field
                                    type="number"
                                    name="sales_price"
                                    className="form-control"
                                    placeholder="Enter Sales Price"
                                    required
                                  />
                                  </div>
                                  <ErrorMessage name="currency" component="div" className="text-danger" />
                                  <ErrorMessage name="sales_price" component="div" className="text-danger" /> 
                                </div>

                                {/* Freight Charges */}
                                <div className="col-md-6 form-group">
                                  <label>Freight Charges <span className="text-warning">(for the whole order)</span></label>
                                  <div className="flex-box">
                                            <Field as="select" name="freight_currency" className="form-control" style={{width:'100px'}}
                                          // Update Formik state
                                      >
                                            {displayCurrency()}
                                    </Field> 
                                  <Field
                                    type="text"
                                    name="freight_charges"
                                    className="form-control"
                                    placeholder="Enter Freight Charges"
                                    required
                                  />
                                  </div>
                                  <ErrorMessage name="freight_charges" component="div" className="text-danger" />
                                </div>
                                {/* Freight Provider */}
                                <div className="col-md-6 form-group">
                                  <label>Freight Provider</label>
                                  <select className="form-select" id="freight_provider" name="freight_provider" 
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setFieldValue(name, value);
                                  }}
                                  >
                                  <option value="">Select Type</option> 
                                  {freightlist.map((row,index)=>
                                  <option value={row.id} key={index}>{row.name}</option>
                                  )}  
                                  </select>
                                  <ErrorMessage name="freight_provider" component="div" className="text-danger" />
                                </div>

                                {/* Royalties */}
                                <div className="col-md-6 form-group">
                                  <label>Royalties</label>
                                  <Field
                                    type="number"
                                    name="royalties"
                                    className="form-control"
                                    placeholder="Enter Royalties"
                                  />
                                  <ErrorMessage name="royalties" component="div" className="text-danger" />
                                </div>

                                {/* Stock Reduction */}
                                <div className="col-md-6 form-group">
                                  <label>Stock Reduction</label>
                                  <Field
                                    type="number"
                                    name="stock_reduction"
                                    className="form-control"
                                    placeholder="Enter Stock Reduction"
                                  />
                                  <ErrorMessage name="stock_reduction" component="div" className="text-danger" />
                                </div>

                                {/* Order Status */}
                                <div className="col-md-6 form-group">
                                  <label>Order Status</label>
                                  <Field
                                    as="select"
                                    name="order_status"
                                    required
                                    className="form-control"
                                  >
                                    <option value="">Select Order Status</option>
                                    <option value="Open">Open</option>
                                    <option value="Confirmed">Confirmed</option>
                                    <option value="Packed">Packed</option>
                                    <option value="Shipped">Shipped</option>
                                    <option value="Delivered">Delivered</option>
                                    <option value="Closed">Closed</option>
                                     <option value="Cancelled">Cancelled</option>
                                     <option value="Returned">Returned</option>

                                  </Field>
                                  <ErrorMessage name="order_status" component="div" className="text-danger" />
                                </div>

                                 {/* Customer Name */}
                                 
                                <p className="text-info pt-2">Customer Info : </p>
                                <div className="col-md-6 form-group">
                                    <label>
                                      <Field type="radio"  name="customer_type" value="newUser" onClick={() => setIsNewCustomer(true)}></Field>
                                      New Customer
                                    </label>

                                    <label>
                                      <Field type="radio"  name="customer_type" value="oldUser" onClick={() => setIsNewCustomer(false)}></Field>
                                      Old Customer
                                    </label>
                                </div>
                               
                                <div className="col-md-6 form-group">
                                  <label>Customer Name</label>
                                   {isNewCustomer == true ? (<Field
                                    type="text"
                                    name="customer_name"
                                    className="form-control"
                                    placeholder="Enter Customer Name"
                                    required
                                  />) : 
                                   (<Field 
                                    as="select"
                                    name="customer_name"
                                    className="form-control"
                                    placeholder="Select customer"
                                    onChange={(e)=> {
                                       let customerobj = customerData.find(customer => customer.customer_name == e.target.value); 
                                       setFieldValue('customer_name', e.target.value); 
                                       setFieldValue('customer_email',customerobj.customer_email); 
                                       setFieldValue('customer_mobile',customerobj.customer_mobile); 
                                       setFieldValue('billing_address',customerobj.billing_address);
                                       setFieldValue('shipping_address', customerobj.shiping_address);
                                    }}
                                    required
                                    > 
                                      <option value="">Select Customer</option>
                                        {customerOption}
                                    </Field>)}
                                  <ErrorMessage name="customer_name" component="div" className="text-danger" />
                                </div>
                                {/* Customer Name */}
                                <div className="col-md-6 form-group">
                                  <label>Customer Email</label>
                                  <Field
                                    type="text"
                                    name="customer_email"
                                    className="form-control"
                                    placeholder="Enter Customer Email"
                                    required
                                    readOnly={!isNewCustomer}
                                  />
                                  <ErrorMessage name="customer_email" component="div" className="text-danger" />
                                </div>
                                {/* Customer Mobile No. */}
                                <div className="col-md-6 form-group">
                                  <label>Customer Mobile No.</label>
                                  <Field
                                    type="text"
                                    name="customer_mobile"
                                    className="form-control"
                                    placeholder="Enter Customer Mobile No."
                                    required
                                  />
                                  <ErrorMessage name="customer_mobile" component="div" className="text-danger" />
                                </div>
                                
                                {/* Customer billing address */}
                                   <div className="col-md-6 form-group">
                                  <label>Billing address</label>
                                  <Field
                                    type="text"
                                    name="billing_address"
                                    className="form-control"
                                    placeholder="Enter Billing Address"
                                    required
                                  />
                                  <ErrorMessage name="Billing Address" component="div" className="text-danger" />
                                </div>

                                  {/* Customer shipping address */}
                                   <div className="col-md-6 form-group">
                                  <label>Shipping address</label>
                                  <Field
                                    type="text"
                                    name="shipping_address"
                                    className="form-control"
                                    placeholder="Enter Shipping Address"
                                    required
                                  />
                                  <ErrorMessage name="Shipping Address" component="div" className="text-danger" />
                                </div>
                              </div>

                              {/* Submit + Close */}
                              <br />
                              <div className="row">
                                <div className="col-md-6">
                                    <Submissionbtn issaved={submitted} label1='Save' label2='Saving'/>
                                </div>

                                {<HandleClose/>}
                              </div>
                            </Form>
                          )}
                      </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddSale;
